import { BookingStateEnum, CalendarType, TenantType } from '../../enums'
import { ManagementTenant } from '../../models'

export const DEFAULT_TENANT: ManagementTenant = {
  features: [],
  type: TenantType.FOOD,
  id: '',
  name: '',
  timezone: '',
  defaultBookingState: BookingStateEnum.OPEN,
  requireMail: false,
  requirePhone: false,
  useLengthOfStay: false,
  markMultipleUsedTables: false,
  highlightOutdated: false,
  thresholdOutdated: 0,
  rooms: [],
  anyroom: false,
  employees: [],
  services: [],
  categories: [],
  includeCancelLinkInCalendarAttachment: false,
  calendarType: CalendarType.MONTH,
  calendarDisplayPreference: 'employee',
  showAddressInCalendar: false,
  showTimeInDashboard: false,
  showStatisticsInDashboard: false,
  visibleDashboardColumns: undefined,
  events: [],
}
